var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7291_208037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8428 6.97453C23.8428 4.86516 22.2912 3.16828 20.374 3.16828C17.7772 3.04687 15.1287 3 12.4222 3H11.5784C8.87841 3 6.22529 3.04687 3.62841 3.16875C1.71591 3.16875 0.164348 4.875 0.164348 6.98437C0.0471601 8.65266 -0.00252745 10.3214 0.000285051 11.9902C-0.00440245 13.6589 0.0487226 15.3292 0.15966 17.0011C0.15966 19.1105 1.71122 20.8214 3.62372 20.8214C6.35185 20.948 9.15028 21.0042 11.9956 20.9995C14.8456 21.0089 17.6362 20.9495 20.3675 20.8214C22.2847 20.8214 23.8362 19.1105 23.8362 17.0011C23.9487 15.3277 24.0003 13.6589 23.9956 11.9855C24.0062 10.3167 23.9553 8.64641 23.8428 6.97453ZM9.70341 16.5886V7.37766L16.5003 11.9808L9.70341 16.5886Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7291_208037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/Youtube_Icon.a60169e579d372a0ba9605c2b4ea70f2.svg";
export { ForwardRef as ReactComponent };